"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateEmployeeDto = exports.CreateRoleDto = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const swagger_1 = require("@nestjs/swagger");
class CreateRoleDto {
}
exports.CreateRoleDto = CreateRoleDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 5 }),
    (0, class_validator_1.IsInt)({ message: "Role ID must be a number" }),
    (0, class_validator_1.IsNotEmpty)({ message: "Role ID should not be empty" }),
    tslib_1.__metadata("design:type", Number)
], CreateRoleDto.prototype, "roleId", void 0);
class CreateEmployeeDto {
}
exports.CreateEmployeeDto = CreateEmployeeDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 16 }),
    (0, class_validator_1.IsInt)({ message: "Salutation must be a number" }),
    (0, class_validator_1.IsNotEmpty)({ message: "Salutation should not be empty" }),
    tslib_1.__metadata("design:type", Number)
], CreateEmployeeDto.prototype, "salutationLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "John" }),
    (0, class_validator_1.IsString)({ message: "First name must be a string" }),
    (0, class_validator_1.IsNotEmpty)({ message: "First name should not be empty" }),
    (0, class_validator_1.MinLength)(3, { message: "First name must be at least 3 characters long" }),
    (0, class_validator_1.MaxLength)(100, { message: "First name must be at most 100 characters long" }),
    (0, class_validator_1.Matches)(/^[A-Za-z\s]+$/, {
        message: "First name must contain only alphabets",
    }),
    (0, class_transformer_1.Transform)(({ value }) => (value ? value.trim() : value)),
    tslib_1.__metadata("design:type", String)
], CreateEmployeeDto.prototype, "firstName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Doe" }),
    (0, class_validator_1.IsString)({ message: "Last name must be a string" }),
    (0, class_validator_1.IsNotEmpty)({ message: "Last name should not be empty" }),
    (0, class_validator_1.MinLength)(3, { message: "Last name must be at least 3 characters long" }),
    (0, class_validator_1.MaxLength)(100, { message: "Last name must be at most 100 characters long" }),
    (0, class_validator_1.Matches)(/^[A-Za-z\s]+$/, {
        message: "Last name must contain only alphabets",
    }),
    (0, class_transformer_1.Transform)(({ value }) => (value ? value.trim() : value)),
    tslib_1.__metadata("design:type", String)
], CreateEmployeeDto.prototype, "lastName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "jogn@gmail.com" }),
    (0, class_validator_1.IsEmail)({}, { message: "Invalid email ID" }),
    (0, class_validator_1.IsNotEmpty)({ message: "Email ID should not be empty" }),
    tslib_1.__metadata("design:type", String)
], CreateEmployeeDto.prototype, "emailId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "9032150543" }),
    (0, class_validator_1.IsNotEmpty)({ message: "Phone number is required." }),
    (0, class_validator_1.IsString)({ message: "Phone number must be a string." }),
    (0, class_validator_1.Matches)(/^[+]?[0-9]{10,12}$/, {
        message: "Phone number must be a valid number.",
    }),
    tslib_1.__metadata("design:type", String)
], CreateEmployeeDto.prototype, "mobile", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 101 }),
    (0, class_validator_1.IsInt)({ message: "Branch ID must be a number" }),
    (0, class_validator_1.IsNotEmpty)({ message: "Branch ID should not be empty" }),
    tslib_1.__metadata("design:type", Number)
], CreateEmployeeDto.prototype, "branchId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 6 }),
    (0, class_validator_1.IsInt)({ message: "Department ID must be a number" }),
    (0, class_validator_1.IsNotEmpty)({ message: "Department ID should not be empty" }),
    tslib_1.__metadata("design:type", Number)
], CreateEmployeeDto.prototype, "departmentId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 8 }),
    (0, class_validator_1.IsInt)({ message: "Vertical ID must be a number" }),
    (0, class_validator_1.IsNotEmpty)({ message: "Vertical ID should not be empty" }),
    tslib_1.__metadata("design:type", Number)
], CreateEmployeeDto.prototype, "verticalId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 2 }),
    (0, class_validator_1.IsInt)({ message: "Organisation ID must be a number" }),
    (0, class_validator_1.IsNotEmpty)({ message: "Organisation ID should not be empty" }),
    tslib_1.__metadata("design:type", Number)
], CreateEmployeeDto.prototype, "organisationId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 2 }),
    (0, class_validator_1.IsInt)({ message: "Designation ID must be a number" }),
    (0, class_validator_1.IsNotEmpty)({ message: "Designation ID should not be empty" }),
    tslib_1.__metadata("design:type", Number)
], CreateEmployeeDto.prototype, "designationId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ example: 27 }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Reporting Manager Employee ID must be a number" }),
    tslib_1.__metadata("design:type", Number)
], CreateEmployeeDto.prototype, "reportingManagerEmployeeId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "IIRM_EMP12" }),
    (0, class_validator_1.IsString)({ message: "IIRM Employee ID must be a string" }),
    (0, class_validator_1.IsNotEmpty)({ message: "IIRM Employee ID should not be empty" }),
    tslib_1.__metadata("design:type", String)
], CreateEmployeeDto.prototype, "iirmEmpId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "johndoe" }),
    (0, class_validator_1.IsString)({ message: "Login Name must be a string" }),
    (0, class_validator_1.IsNotEmpty)({ message: "Login Name should not be empty" }),
    tslib_1.__metadata("design:type", String)
], CreateEmployeeDto.prototype, "loginName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Employee roles",
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Employee roles are required." }),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Type)(() => Array),
    tslib_1.__metadata("design:type", Array)
], CreateEmployeeDto.prototype, "roles", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ example: [27, 28] }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Type)(() => Array),
    tslib_1.__metadata("design:type", Array)
], CreateEmployeeDto.prototype, "reportees", void 0);
